// T023 — Support-mainnet page event definitions (V2).
//
// Spec: frontend/specs/030-mainnet-support-page/spec.md FR-090.
// Payloads: frontend/specs/030-mainnet-support-page/supplementary/data-model.md
// § "Analytics event payloads".
//
// V2 explicitly does NOT emit donation submit/complete/failed events because
// donations happen via external mainnet wallets (no in-app submit flow).

import type { EventDefinition } from './navigation';

export type SupportMainnetPageViewedProperties = {
  locale: string;
};

export type LandingProductCtaClickedProperties = {
  destination: '/markets';
  surface: 'hero' | 'header' | 'mobile' | 'lower';
};

export type SupportMainnetDonateQrViewedProperties = {
  recipient: string;
};

export type SupportMainnetDonateAddressCopiedProperties = {
  recipient: string;
};

export type SupportMainnetDonateQrAmountChangedProperties = {
  asset: 'USDC' | 'SOL';
  amount_usd_cents: number | null;
};

export type SupportMainnetShareChannel =
  | 'x'
  | 'telegram'
  | 'discord'
  | 'copy_link'
  | 'follow_discord'
  | 'follow_telegram'
  | 'follow_x'
  | 'follow_reddit';

export type SupportMainnetShareClickedProperties = {
  channel: SupportMainnetShareChannel;
};

export type SupportMainnetFaqOpenedProperties = {
  id: string;
};

export const SUPPORT_MAINNET_PAGE_VIEWED: EventDefinition<SupportMainnetPageViewedProperties> = {
  name: 'support_mainnet_page_viewed',
};

export const LANDING_PRODUCT_CTA_CLICKED: EventDefinition<LandingProductCtaClickedProperties> = {
  name: 'landing_product_cta_clicked',
};

export const SUPPORT_MAINNET_DONATE_QR_VIEWED: EventDefinition<SupportMainnetDonateQrViewedProperties> =
  {
    name: 'support_mainnet_donate_qr_viewed',
  };

export const SUPPORT_MAINNET_DONATE_ADDRESS_COPIED: EventDefinition<SupportMainnetDonateAddressCopiedProperties> =
  {
    name: 'support_mainnet_donate_address_copied',
  };

export const SUPPORT_MAINNET_DONATE_QR_AMOUNT_CHANGED: EventDefinition<SupportMainnetDonateQrAmountChangedProperties> =
  {
    name: 'support_mainnet_donate_qr_amount_changed',
  };

export const SUPPORT_MAINNET_SHARE_CLICKED: EventDefinition<SupportMainnetShareClickedProperties> =
  {
    name: 'support_mainnet_share_clicked',
  };

export const SUPPORT_MAINNET_FAQ_OPENED: EventDefinition<SupportMainnetFaqOpenedProperties> = {
  name: 'support_mainnet_faq_opened',
};
